<template>
    <div class="page-download">

        <div id="dimmed-wechat" :class="{'st-show' : isWechat}">
            <img src="@/assets/download/img_open_browser.png">
        </div>

        <div id="alert-andriod" :class="{'st-show' : isShowAndroidPopup}">

            <div class="alert__dimmed" @click="closeAndroidPopup"></div>

            <div class="alert__box">
                <button class="alert__close" @click="closeAndroidPopup">
                    <img src="@/assets/download/img-close-icon.svg" class="close-icon">
                </button>
                <div class="alert__title">
                    都都GO
                </div>

                <div class="alert__subtitle">
                    本安卓版本仅供中国大陆地区使用，
                    <br>
                    在其他国家或地区可能无法正常使用。
                </div>

                <ul class="alert__precautions">
                    <li>如果您已经安装了“都都GO”，<br class="br-phone"> 您可以启动它来获取适用的更新。</li>
                    <li>如果您发现更新之后存在两个“都都GO”，<br class="br-phone"> 请手动删除之前的版本</li>
                    <li class="point-precaution">需要Android系统版本5.1.0，<br class="br-phone">可使用存储空间1.5GB及以上</li>
                </ul>

                <a href="https://todoenglish-apk-download.enuma.cn/todoenglish-china-release.apk" class="alert__button" >
                    下载
                </a>
            </div>

        </div>

        <div id="download__pageview">
            <img src="@/assets/download/img-home-top.svg" class="img-bg" alt="" />

            <header class="download__header">
                <img src="@/assets/download/img-coupon-logo-cn.png" class="english-logo">
            </header>

            <div class="pageview__content">
                <h1 class="download__title">
                    爱上英语 快乐空间
                </h1>

                <div class="download__biglogo">
                    <img src="@/assets/download/img-home-cn-logo.png" alt="Todo English Main Banner Logo">
                </div>

                <div class="download__buttons">
                    <a class="download__appstore" href="https://apps.apple.com/cn/app/id1500379448" target="_blank">
                        <img src="@/assets/download/img-appstore-wh.png" alt="">
                    </a>
                    <a href="#" @click.prevent="openAndroidPopup">
                        <img src="@/assets/download/img-android-wh.svg" alt="">
                    </a>
                </div>

                <a href="http://mp.weixin.qq.com/s?__biz=MzA5MjkxMzY1NA==&mid=2247485550&idx=2&sn=6b4ee275eaa2848592e46c75382c3adc&chksm=9064a2f7a7132be1c53e747aae2d47a27580c6710cbf8a783695965ec49fb6a41d4d66b6ee97&scene=18#wechat_redirect" class="download__moredetail" target="_blank">
                    查看都都GO详细介绍
                    <img src="@/assets/download/img-homepage-arrow.svg" class="img_homepage_arrow">
                </a>
            </div>

        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            isShowAndroidPopup : false,
            isWechat : false,
        }
    },
    methods : {
        openAndroidPopup() {
            this.isShowAndroidPopup = true;
        },

        closeAndroidPopup() {
            this.isShowAndroidPopup = false;
        },

    },
    mounted(){
        const userAgent = window.navigator.userAgent.toLowerCase()
        if (userAgent.indexOf('wechat') > -1 ||
            userAgent.indexOf('micromessenger') > -1){
            this.isWechat = true;
        }
    }
}
</script>

<style scoped>

br.br-phone {
    display: none;
}
*{
    color: #342d51;
    /* line-height: 1.6em; */
}

#dimmed-wechat {
    position: fixed;
    z-index: 2000;
    top: 0; left: 0;
    width: 100%; height: 100%;
    background: rgba(0,0,0,0.5);
    text-align: right;
    display: none;
}
#dimmed-wechat.st-show {
    display: block;
}
#dimmed-wechat  img {
    margin-right: 20px;
}

.page-download {
    font-size: 16px;
}

#alert-andriod {
    position: fixed;
    z-index: 1000;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    display: none;
}
#alert-andriod.st-show {
    display: flex;
}

.alert__dimmed {
    top: 0; left: 0;
    background: rgba(0,0,0,0.5);
    width: 100%; height:100%;
    position: absolute;
    z-index: 1;
}
.alert__box {
    font-weight: 300;
    min-width: 500px;
    box-sizing: border-box;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    z-index: 2;
    background-color: #fff;
    padding: 36px 24px;
    border-radius: 14px;
    position: relative;
}

.alert__close {
    border: none;
    background: transparent;
    position: absolute;
    right: 20px; top: 28px;
    display: inline-block;
    cursor: pointer;
}

.alert__title {
    font-size: 36px;
    font-weight: 300;
}
.alert__subtitle {
    margin-top: 26px;
}

.alert__precautions {
    margin-top: 26px;
    font-size: 14px;
}

.alert__precautions  li {
    list-style: none;
    color: #999;
}

.alert__precautions .point-precaution {
    color:rgb(230, 0, 0);
    font-size: 16px;
    font-weight: 400;
}


.alert__precautions li::before {
    content: '• ';
}

.alert__button {
    margin-top: 34px;
    width: 270px;
    padding: 17px 0 ;
    box-sizing: border-box;
    display: inline-block;
    text-align: center;
    font-size: 22px;
    background: #F7419C;
    font-weight: 700;
    color: #fff;
    border-radius: 25px;
    box-shadow: 0 5px 0 #DF2B85;
}

.page-download {
    width: 100%; min-height: 100vh;
    font-family: 'Noto Sans SC', sans-serif !important;
    overflow-x: hidden;
}

#download__pageview {
    width: 100%; min-height: 100vh;
    position: relative;
    background-color: #000; /* #89ad4a; */
    box-sizing: border-box;
    
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 0;
}

.img-bg {
    position: absolute;
    top: -55px;
}

.pageview__content {
    width: 100%;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    position: absolute;
    top: 200px;
}

.download__header {
    position: absolute;
    max-width: 1100px;
    width: 100%;
    left: 50%;
    top: 25px;
    transform: translateX(-50%);
}
.download__header img {
    margin-left: 50px;
    width: 79px;
}

.download__title {
    font-size: 80px;
    font-weight: 700;
    line-height: 1.15em;
    /* margin-top: -100px; */
}

.download__biglogo {
    margin-top: 23px;
    z-index: 20;
}
.download__biglogo img{
    width: 481px;
}

.download__buttons {
    display: flex;
    margin-top: 35px;
}

.download__appstore img{
    width: 120px;
}

.download__buttons a {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 220px;
    box-sizing: border-box;
    border-radius: 25px;
    overflow: hidden;
    background-color: #372c77;
    padding: 15px 18px;
}
.download__buttons a ~ a {
    margin-left: 20px;
}
.download__moredetail {
    margin-top: 28px;
    display: flex;
    align-items: center;
    font-size: 22px;
    font-weight: 500;

}
.download__moredetail img{
    margin-left: 5px;
}


@media screen and (max-width: 768px) {
    br.br-phone {
        display: block;
    }
    .alert__box {
        width: 100%;
        margin: 50px;
        border-radius: 24px;
        padding: 50px;
        padding-top: 40px;
        padding-bottom: 60px;
    }

    .alert__close {
        right: 43px;
        top: 50px;
    }

    .alert__title {
        font-size: 64px;
    }
    .alert__subtitle {
        margin-top: 40px;
        font-size: 24px;
    }

    .alert__precautions {
        font-size: 22px;
        margin-top: 46px;
        text-align: center;
    }

    .alert__precautions  li {
        margin-top: 22px;
    }
    .alert__precautions .point-precaution {
        font-size: 22px !important;
    }
    .alert__button {
        width: 100%;
        font-size: 28px;
        padding: 25px 0 ;
        border-radius: 30px;
        margin-top: 62px;
    }

    #download__pageview {
        background-image : url('../../assets/download/img-home-top-mo.png');
        background-size: cover;
        background-position: top center;
        background-repeat: no-repeat;
    }

    .download__header {
        pointer-events: none;
    }

    .download__header img {
        margin-left: 22px;
        width: 60px;
    }

    .download__title {
        margin-top: -35px;
        font-size: 60px;
    }

    .img-bg {
        display: none;
        top: -100px;
    }

    .pageview__content {
        top: 200px;
    }
    
    .download__biglogo {
        width: 90%;
        box-sizing: border-box;
        padding: 0 30px;
    }
    .download__biglogo img{
        width: 100%;
    }

    .download__buttons {
        width: 90%;
        flex-direction: column;
        padding: 0 40px;
        box-sizing: border-box;
    }

    .download__buttons a {
        width: 100%;
        box-sizing: border-box;
        padding: 15px;
        border-radius: 35px;
    }
    .download__buttons a img{
        transform : scale(0.9);
    }
    .download__buttons a ~ a {
        margin-top: 15px;
        margin-left: 0
    }
    .download__moredetail {
        font-size: 18px;
    }
    .download__moredetail img{
        transform:scale(0.9);
        margin-left: 7px;
    }
}

@media screen and (max-width: 500px) {
    .download__title {
        font-size: 36px !important;
    }

    .img-bg {
        top: -200px !important;
    }

    .pageview__content {
        top: 150px !important;
    }

    .download__biglogo {
        padding: 0;
        width: 85%;
    }

    .download__biglogo {
        width: 90%;
    }
}
</style>